import { createRequest } from '@shared/services';

export async function userLogout() {
    if (typeof window === 'undefined') {
        throw new Error('userLogout is not supported in server side');
    }

    const request = createRequest({
        url: '/user/logout',
        method: 'GET',
        useProxyService: true,
        withCredentials: true,
        params: {
            pathname: window.location.pathname,
            target: window.location.host,
            origin: window.location.origin,
        },
    });

    return request.execute();
}
